<xi-generic-modal
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="400px"
  (onClose)="cancel()"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children">
        <div *transloco="let t; read: 'download-as-dialog'" class="xi-modal__container">
          <h2 class="xi-modal__title">{{ t('download-as', { label }) }}</h2>

          <div class="xi-modal__content">
            <form autocomplete="off">
              <div class="filename-container">
                <div class="xi-input-field-wrapper">
                  <xi-input-field
                    [label]="t('file-name')"
                    [placeholder]="t('enter-here')"
                    name="fileName"
                    [(ngModel)]="result.fileName"
                    required
                    [status]="fileNameStatus"
                    (onChange)="onValidateFileName()"
                    icon="cancel"
                    (onIconClick)="result.fileName = ''; onValidateFileName()"
                  ></xi-input-field>
                </div>

                <div class="filetype-container">
                  <div class="filetype-label">{{ t('file-type') }}</div>

                  <div class="filetype-text">{{ fileFormatText }}</div>
                </div>
              </div>

              <div class="xi-input-field-wrapper">
                <xi-input-field
                  [label]="t('record-count', { limit: (limit | number) })"
                  name="recordCount"
                  [(ngModel)]="result.recordCount"
                  required
                  [status]="recordCountStatus"
                  (onChange)="onValidateRecordCount()"
                  type="number"
                  [min]="1"
                  [max]="limit"
                ></xi-input-field>
              </div>

              <div class="xi-input-field-wrapper">
                <xi-dropdown
                  [label]="t('choose-records-by')"
                  select="single"
                  [value]="result.sortOrder"
                  [data]="sortOrders"
                  [stretch]="true"
                  [direction]="12"
                  (onValueChange)="result.sortOrder = $event.detail.selected.id"
                ></xi-dropdown>
              </div>
            </form>
          </div>

          <div class="download-as-dialog__action xi-modal__actions">
            <xi-default-button
              [text]="t('download')"
              [disabled]="hasError"
              (onClick)="confirm()"
            ></xi-default-button>
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
